/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
/**
 * Awvent - Meetings API
 * Awvent Meetings Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {
    HttpClient,
    HttpEvent,
    HttpHeaders, HttpParams,
    HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { DemoGoal } from '../../../../shared/common/enums/demoGoal';
import { DemoType } from '../../../../shared/common/enums/demoType';
import { MeetingStatus } from '../../../../shared/common/enums/meetingStatus';
import { SalesStage } from '../../../../shared/common/enums/salesStage';
import { Int32WebApiResponse } from '../../../../shared/common/models/int32WebApiResponse';
import { MeetingAddAttendanceCommand } from '../model/meetingAddAttendanceCommand';
import { MeetingAddScreenshotsCommand } from '../model/meetingAddScreenshotsCommand';
import { MeetingAddVideoAttachmentsCommand } from '../model/meetingAddVideoAttachmentsCommand';
import { MeetingCancelCommand } from '../model/meetingCancelCommand';
import { MeetingCreateCommand } from '../model/meetingCreateCommand';
import { MeetingDtoListWebApiPagedResponse } from '../model/meetingDtoListWebApiPagedResponse';
import { MeetingDtoWebApiResponse } from '../model/meetingDtoWebApiResponse';
import { MeetingRemoveScreenshotsCommand } from '../model/meetingRemoveScreenshotsCommand';
import { MeetingRemoveVideoAttachmentsCommand } from '../model/meetingRemoveVideoAttachmentsCommand';
import { MeetingUpdateActualTimesCommand } from '../model/meetingUpdateActualTimesCommand';
import { MeetingUpdateCommand } from '../model/meetingUpdateCommand';
import { MeetingUpdateStatusCommand } from '../model/meetingUpdateStatusCommand';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';

 @Injectable()
 export class MeetingService {

     public defaultHeaders = new HttpHeaders();
     public configuration = new Configuration();

    protected basePath = environment.api.meetings;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingAddAttendancePut(xTenantId: string, body?: MeetingAddAttendanceCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingAddAttendancePut(xTenantId: string, body?: MeetingAddAttendanceCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingAddAttendancePut(xTenantId: string, body?: MeetingAddAttendanceCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingAddAttendancePut(xTenantId: string, body?: MeetingAddAttendanceCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingAddAttendancePut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/AddAttendance`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingAddScreenshotsPut(xTenantId: string, body?: MeetingAddScreenshotsCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingAddScreenshotsPut(xTenantId: string, body?: MeetingAddScreenshotsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingAddScreenshotsPut(xTenantId: string, body?: MeetingAddScreenshotsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingAddScreenshotsPut(xTenantId: string, body?: MeetingAddScreenshotsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingAddScreenshotsPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/AddScreenshots`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingAddVideoAttachmentsPut(xTenantId: string, body?: MeetingAddVideoAttachmentsCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingAddVideoAttachmentsPut(xTenantId: string, body?: MeetingAddVideoAttachmentsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingAddVideoAttachmentsPut(xTenantId: string, body?: MeetingAddVideoAttachmentsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingAddVideoAttachmentsPut(xTenantId: string, body?: MeetingAddVideoAttachmentsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingAddVideoAttachmentsPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/AddVideoAttachments`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingCancelPut(xTenantId: string, body?: MeetingCancelCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingCancelPut(xTenantId: string, body?: MeetingCancelCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingCancelPut(xTenantId: string, body?: MeetingCancelCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingCancelPut(xTenantId: string, body?: MeetingCancelCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingCancelPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/Cancel`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param userEmail
     * @param businessAccountId
     * @param companyName
     * @param fromTime
     * @param toTime
     * @param status
     * @param salesStage
     * @param type
     * @param goal
     * @param isPublic
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param dealId
     * @param includeDrafts
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // SPEC-meet-ux-019 / GAP-MEET-UX-003 — MANUAL hand-extension. The backend
    // MeetingBizQuery.DealId filter has been shipped since SPEC-backend-021
    // (2026-06), but this swagger-generated client has never been regenerated
    // to expose it. Rather than regenerate the full swagger client and pull in
    // sweeping fallout, we hand-extend the four overloads with an optional
    // `dealId?: string` per the SPEC-021 / SPEC-webplanner-043 hand-extension
    // precedent. Swagger regeneration WILL DROP this trailing parameter unless
    // preserved (same manual-preservation contract as `dealId`, `buildId`,
    // `roomOpenedAt` on MeetingDto). Consumers: qualification-review page.
    //
    // SPEC-meet-ux-029 / GAP-MEET-UX-016 — second MANUAL hand-extension. Adds
    // `includeDrafts?: boolean` at positional slot 18 (immediately after
    // `dealId` at slot 17), matching SPEC-backend-034's `IncludeDrafts?: bool?`
    // query-string param. When `true`, the query string carries
    // `&IncludeDrafts=true` and the backend response includes Draft-status
    // rows. When `undefined`/`false`, the param is OMITTED and the backend
    // applies its default (excludes Drafts). Consumers: `/sessions` Drafts tab
    // (opts in). `/queue/:oppId` and every other caller take the default.
    // Same swagger-regeneration preservation contract as `dealId` above.
    public meetingGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, dealId?: string, includeDrafts?: boolean, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoListWebApiPagedResponse>;
    public meetingGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, dealId?: string, includeDrafts?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoListWebApiPagedResponse>>;
    public meetingGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, dealId?: string, includeDrafts?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoListWebApiPagedResponse>>;
    public meetingGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, dealId?: string, includeDrafts?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userEmail !== undefined && userEmail !== null) {
            queryParameters = queryParameters.set('UserEmail', <any>userEmail);
        }
        if (businessAccountId !== undefined && businessAccountId !== null) {
            queryParameters = queryParameters.set('BusinessAccountId', <any>businessAccountId);
        }
        if (companyName !== undefined && companyName !== null) {
            queryParameters = queryParameters.set('CompanyName', <any>companyName);
        }
        if (fromTime !== undefined && fromTime !== null) {
            queryParameters = queryParameters.set('FromTime', <any>fromTime.toISOString());
        }
        if (toTime !== undefined && toTime !== null) {
            queryParameters = queryParameters.set('ToTime', <any>toTime.toISOString());
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (salesStage !== undefined && salesStage !== null) {
            queryParameters = queryParameters.set('SalesStage', <any>salesStage);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('Type', <any>type);
        }
        if (goal !== undefined && goal !== null) {
            queryParameters = queryParameters.set('Goal', <any>goal);
        }
        if (isPublic !== undefined && isPublic !== null) {
            queryParameters = queryParameters.set('IsPublic', <any>isPublic);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', <any>element);
            })
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', <any>isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        // SPEC-meet-ux-019 / GAP-MEET-UX-003 — hand-extended DealId filter (see
        // signature note above). Backend MeetingBizQuery.DealId shipped in
        // SPEC-backend-021.
        if (dealId !== undefined && dealId !== null) {
            queryParameters = queryParameters.set('DealId', <any>dealId);
        }
        // SPEC-meet-ux-029 / GAP-MEET-UX-016 — hand-extended IncludeDrafts opt-in
        // (see signature note above). Backend MeetingBizQuery.IncludeDrafts?
        // shipped in SPEC-backend-034; when omitted, the backend excludes
        // Draft-status rows by default.
        if (includeDrafts === true) {
            queryParameters = queryParameters.set('IncludeDrafts', <any>true);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MeetingDtoListWebApiPagedResponse>('get',`${this.basePath}/Meeting`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param xTenantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling meetingIdGet.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingIdGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MeetingDtoWebApiResponse>('get',`${this.basePath}/Meeting/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param userEmail 
     * @param businessAccountId 
     * @param companyName 
     * @param fromTime 
     * @param toTime 
     * @param status 
     * @param salesStage 
     * @param type 
     * @param goal 
     * @param isPublic 
     * @param orderBy 
     * @param isOrderByDescending 
     * @param searchText 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingMeetingsCountGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<Int32WebApiResponse>;
    public meetingMeetingsCountGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Int32WebApiResponse>>;
    public meetingMeetingsCountGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Int32WebApiResponse>>;
    public meetingMeetingsCountGet(xTenantId: string, userEmail?: string, businessAccountId?: string, companyName?: string, fromTime?: Date, toTime?: Date, status?: MeetingStatus, salesStage?: SalesStage, type?: DemoType, goal?: DemoGoal, isPublic?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingMeetingsCountGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userEmail !== undefined && userEmail !== null) {
            queryParameters = queryParameters.set('UserEmail', <any>userEmail);
        }
        if (businessAccountId !== undefined && businessAccountId !== null) {
            queryParameters = queryParameters.set('BusinessAccountId', <any>businessAccountId);
        }
        if (companyName !== undefined && companyName !== null) {
            queryParameters = queryParameters.set('CompanyName', <any>companyName);
        }
        if (fromTime !== undefined && fromTime !== null) {
            queryParameters = queryParameters.set('FromTime', <any>fromTime.toISOString());
        }
        if (toTime !== undefined && toTime !== null) {
            queryParameters = queryParameters.set('ToTime', <any>toTime.toISOString());
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (salesStage !== undefined && salesStage !== null) {
            queryParameters = queryParameters.set('SalesStage', <any>salesStage);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('Type', <any>type);
        }
        if (goal !== undefined && goal !== null) {
            queryParameters = queryParameters.set('Goal', <any>goal);
        }
        if (isPublic !== undefined && isPublic !== null) {
            queryParameters = queryParameters.set('IsPublic', <any>isPublic);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', <any>element);
            })
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', <any>isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Int32WebApiResponse>('get',`${this.basePath}/Meeting/MeetingsCount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param xRequestId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingPost(xTenantId: string, body?: MeetingCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingPost(xTenantId: string, body?: MeetingCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingPost(xTenantId: string, body?: MeetingCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingPost(xTenantId: string, body?: MeetingCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingPost.');
        }



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('post',`${this.basePath}/Meeting`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingPut(xTenantId: string, body?: MeetingUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingPut(xTenantId: string, body?: MeetingUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingPut(xTenantId: string, body?: MeetingUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingPut(xTenantId: string, body?: MeetingUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingRemoveScreenshotsPut(xTenantId: string, body?: MeetingRemoveScreenshotsCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingRemoveScreenshotsPut(xTenantId: string, body?: MeetingRemoveScreenshotsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingRemoveScreenshotsPut(xTenantId: string, body?: MeetingRemoveScreenshotsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingRemoveScreenshotsPut(xTenantId: string, body?: MeetingRemoveScreenshotsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingRemoveScreenshotsPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/RemoveScreenshots`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingRemoveVideoAttachmentsPut(xTenantId: string, body?: MeetingRemoveVideoAttachmentsCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingRemoveVideoAttachmentsPut(xTenantId: string, body?: MeetingRemoveVideoAttachmentsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingRemoveVideoAttachmentsPut(xTenantId: string, body?: MeetingRemoveVideoAttachmentsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingRemoveVideoAttachmentsPut(xTenantId: string, body?: MeetingRemoveVideoAttachmentsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingRemoveVideoAttachmentsPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/RemoveVideoAttachments`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingUpdateActualTimesPut(xTenantId: string, body?: MeetingUpdateActualTimesCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingUpdateActualTimesPut(xTenantId: string, body?: MeetingUpdateActualTimesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingUpdateActualTimesPut(xTenantId: string, body?: MeetingUpdateActualTimesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingUpdateActualTimesPut(xTenantId: string, body?: MeetingUpdateActualTimesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingUpdateActualTimesPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/UpdateActualTimes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meetingUpdateStatusPut(xTenantId: string, body?: MeetingUpdateStatusCommand, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingUpdateStatusPut(xTenantId: string, body?: MeetingUpdateStatusCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingUpdateStatusPut(xTenantId: string, body?: MeetingUpdateStatusCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingUpdateStatusPut(xTenantId: string, body?: MeetingUpdateStatusCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingUpdateStatusPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('put',`${this.basePath}/Meeting/UpdateStatus`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-webplanner-024 AC-12 — rep-driven Send invite. Hand-rolled (not
     * Swagger-generated) so the agents-api / Mailgun port stays close to the
     * implementation. The backend handler validates the meeting is in Draft,
     * dispatches via IInviteEmailTransport, flips status to Scheduled, and
     * returns the updated MeetingDto with `sentFromInbox` populated for the
     * chat confirmation turn.
     *
     * @param id The meeting id (from the route /Meeting/{id}/SendInvite)
     * @param xTenantId Required tenant header (no global interceptor supplies it)
     */
    public meetingSendInvite(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<MeetingDtoWebApiResponse>;
    public meetingSendInvite(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MeetingDtoWebApiResponse>>;
    public meetingSendInvite(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MeetingDtoWebApiResponse>>;
    public meetingSendInvite(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling meetingSendInvite.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingSendInvite.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('x-tenant-id', String(xTenantId));

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<MeetingDtoWebApiResponse>('post',`${this.basePath}/Meeting/${encodeURIComponent(String(id))}/SendInvite`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-webplanner-043 / GAP-BACKEND-045 AC2 — Invite preview.
     *
     * POST /Meeting/{id}/InvitePreview returns byte-identical HTML to what
     * SendInvite would deliver for the same meeting, optionally overlaid with
     * live compose-card edits (subject/description/to/cc/bcc). The FE binds
     * the returned HTML into a sandboxed iframe on the compose card so the rep
     * sees the full assembled artifact (header + CTAs + footer) before Send —
     * WYSIWYG enforcement per [[feedback_ivaan_helper_not_hidden_actor]].
     *
     * MANUAL — hand-added post-swagger-gen (same preservation contract as
     * meetingSendInvite above). Sets x-tenant-id explicitly per
     * project_meetux_http_header_convention (no global interceptor).
     */
    public meetingInvitePreview(
        id: string,
        xTenantId: string,
        overlay: { subject?: string; description?: string; to?: string[]; cc?: string[]; bcc?: string[] }
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling meetingInvitePreview.');
        }
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling meetingInvitePreview.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('x-tenant-id', String(xTenantId));

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        const httpHeaderAccepts: string[] = ['application/json', 'text/json'];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const httpContentTypeAccepts: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(httpContentTypeAccepts);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',
            `${this.basePath}/Meeting/${encodeURIComponent(String(id))}/InvitePreview`,
            {
                body: overlay ?? {},
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
            }
        );
    }

}
